import { useQuery } from "@tanstack/react-query";

import { supabase } from "~/integrations/supabase/client";
import { ClientActivationHistory } from "~/types/client";

// Activation/deactivation audit trail for a client (newest first), with the acting
// user's name resolved. Backed by the get_client_activation_history RPC.
export const useClientActivationHistory = (clientId?: string | null) => {
  const { data: history = [], isLoading } = useQuery({
    queryKey: ["client-activation-history", clientId],
    enabled: Boolean(clientId),
    queryFn: async () => {
      // RPC is not yet in the generated Database type -> cast, per repo convention.
      const { data, error } = await supabase.rpc(
        "get_client_activation_history" as never,
        { p_client_id: clientId } as never
      );

      if (error) throw error;
      return (data ?? []) as ClientActivationHistory[];
    },
  });

  // When the client is currently inactive, the newest row is the deactivation event.
  const latestDeactivation =
    history.find((row) => row.is_active === false) ?? null;

  return { history, latestDeactivation, isLoading };
};
